<ion-tabs>
  <ion-tab-bar slot="bottom">
    <ion-tab-button (click)="setCurrentTab(p.url)" [routerLink]="[p.url]" [tab]="p.url"
      *ngFor="let p of appPages; let i = index" [class.color-primary]="rla.isActive" routerLinkActive="active"
      #rla="routerLinkActive">
      <ion-icon [name]="rla.isActive ? p.icon : p.icon+'-outline'"></ion-icon>
      <ion-label>{{ p.label | translate }}</ion-label>
    </ion-tab-button>
  </ion-tab-bar>
</ion-tabs>
